import { useEffect, useState } from "react"
import useErroPadrao from "../../hooks/useErroPadrao";
import useHelp from "../../hooks/useHelp";
import { useNavigate, Link } from "react-router-dom";
import { CHAVE_TOKEN, real, dataBR, linkWhatsApp } from "../../utils/formata";
import { Vazio, EsqueletoCartoes } from "../Components/Estado";

function KPI({ titulo, valor, icone, cor, sub, larga, heroi }) {
    const classes = ["card-estat"];
    if (heroi) classes.push("card-heroi");
    if (larga) classes.push("largura-total");

    return (
        <div className={classes.join(" ")} style={{"--cor-acento": cor}}>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10}}>
                <span className="estat-rotulo">{titulo}</span>
                <i className={icone} style={{color: cor, fontSize: heroi ? "1.5rem" : "1.2rem", flexShrink: 0, opacity: 0.9}}></i>
            </div>
            <div className="estat-numero" style={{color: cor}}>{valor}</div>
            {sub && <div className="estat-apoio">{sub}</div>}
        </div>
    );
}

function mensagemCobranca(parcela) {
    const empresa = parcela.Emprestimo?.Empresa || {};
    return `Olá ${empresa.responsavel || ""}! Aqui é da Help Empresarial. ` +
        `A parcela ${parcela.numero} do contrato #${parcela.EmprestimoId}, no valor de ${real(parcela.valor)}, ` +
        `venceu em ${dataBR(parcela.dataVencimento)}. Podemos acertar o pagamento? Qualquer dúvida estou à disposição! 🤝`;
}

export default function Home() {
    const [dados, setDados] = useState(null);
    const [carregando, setCarregando] = useState(true);
    const { consultarDashboard } = useHelp();
    const { setErroPadrao } = useErroPadrao();
    const navigate = useNavigate();

    useEffect(() => {
        if (!!localStorage.getItem(CHAVE_TOKEN)) {
            consultarDashboard()
                .then((data) => setDados(data))
                .catch((error) => setErroPadrao(error))
                .finally(() => setCarregando(false));
        } else {
            navigate("/login");
        }
    }, [consultarDashboard, setErroPadrao, navigate]);

    if (carregando || !dados) {
        return (
            <div className="pagina">
                <h2 className="he-titulo">Dashboard <span className="he-dourado">Financeiro</span></h2>
                <p className="subtitulo-pagina">Carregando os números de hoje...</p>
                <div style={{marginTop: 18}}>
                    <EsqueletoCartoes quantidade={3} heroi/>
                </div>
                <div className="esqueleto-cartao" style={{marginTop: 16, gap: 14}}>
                    <div className="esqueleto" style={{width: "55%", height: 16}}></div>
                    <div className="esqueleto" style={{width: "100%", height: 120}}></div>
                </div>
            </div>
        );
    }

    const { caixa, carteira, alertas, grafico7dias, ultimasMovimentacoes } = dados;
    const maiorValorGrafico = Math.max(...grafico7dias.map(g => Math.max(g.entradas, g.saidas)), 1);

    return (
        <div className="pagina">
            <h2 className="he-titulo">Dashboard <span className="he-dourado">Financeiro</span></h2>
            <p className="subtitulo-pagina">O dinheiro do dia, da carteira e o que está atrasado.</p>

            {/* Caixa — o saldo total é o número que manda na tela */}
            <div className="secao-titulo"><i className="bi bi-bank"></i> Caixa</div>
            <div className="cards-estatistica">
                <KPI titulo="Saldo total do caixa" valor={real(caixa.saldoTotal)} icone="bi bi-bank" cor="#d4af37" heroi
                     sub={`Este mês: ${real(caixa.saldoMes)} · entrou ${real(caixa.entradasMes)}, saiu ${real(caixa.saidasMes)}`}/>
                <KPI titulo="Entrou hoje" valor={real(caixa.entradasHoje)} icone="bi bi-arrow-down-circle-fill" cor="#2ecc71"/>
                <KPI titulo="Saiu hoje" valor={real(caixa.saidasHoje)} icone="bi bi-arrow-up-circle-fill" cor="#ff6b5b"/>
                <KPI titulo="Despesas do mês" valor={real(caixa.despesasMes)} icone="bi bi-receipt" cor="#ff9f43"
                     sub={`Gastos do negócio (fora empréstimos) · hoje ${real(caixa.despesasHoje)}`}/>
                <KPI titulo="Saldo do mês" valor={real(caixa.saldoMes)} icone="bi bi-calendar-check" cor={caixa.saldoMes >= 0 ? "#2ecc71" : "#ff6b5b"} larga
                     sub={`Entrou ${real(caixa.entradasMes)} · Saiu ${real(caixa.saidasMes)}`}/>
            </div>

            {/* Carteira */}
            <div className="secao-titulo"><i className="bi bi-cash-stack"></i> Carteira</div>
            <div className="cards-estatistica">
                <KPI titulo="Na rua (a receber)" valor={real(carteira.valorAReceber)} icone="bi bi-cash-stack" cor="#d4af37" sub={`${carteira.emprestimosAtivos} empréstimos ativos`}/>
                <KPI titulo="Empresas clientes" valor={carteira.totalEmpresas} icone="bi bi-buildings" cor="#f3f4f6"/>
                <KPI titulo="Em atraso" valor={real(alertas.valorAtrasado)} icone="bi bi-exclamation-triangle-fill" cor={alertas.parcelasAtrasadas.length > 0 ? "#ff6b5b" : "#2ecc71"} sub={`${alertas.parcelasAtrasadas.length} parcelas atrasadas`} larga/>
            </div>

            <div className="secao-titulo"><i className="bi bi-bell"></i> Cobrança</div>

            <div style={{display: "flex", gap: "1em", flexWrap: "wrap", alignItems: "stretch"}}>
                {/* Atrasadas com cobrança */}
                <div className="he-card sem-rolagem" style={{flex: "1 1 420px", minWidth: 0}}>
                    <h5 className="he-titulo" style={{color: "#ff6b5b"}}><i className="bi bi-alarm"></i> Parcelas Atrasadas</h5>
                    {alertas.parcelasAtrasadas.length === 0 ?
                        <Vazio icone="bi bi-check-circle-fill" tom="verde" titulo="Nenhuma parcela atrasada"
                               texto="Carteira saudável — todo mundo em dia com você."/>
                        :
                        <div className="lista-rolavel">
                        <table className="table table-hover tabela-responsiva tabela-mini">
                            <thead><tr><th>Empresa</th><th>Parcela</th><th>Venceu</th><th>Valor</th><th></th></tr></thead>
                            <tbody>
                                {alertas.parcelasAtrasadas.map((p) => (
                                    <tr key={p.id}>
                                        <td className="principal ordem-primeiro" data-rotulo="Empresa">{p.Emprestimo?.Empresa?.nomeFantasia || p.Emprestimo?.Empresa?.razaoSocial}</td>
                                        <td data-rotulo="Parcela">{p.numero}</td>
                                        <td data-rotulo="Venceu" style={{color: "#ff6b5b"}}>{dataBR(p.dataVencimento)}</td>
                                        <td className="destaque" data-rotulo="Valor">{real(p.valor)}</td>
                                        <td className="acoes">
                                            <div className="acoes-linha uma-coluna" style={{justifyContent: "flex-end"}}>
                                                <a className="btn btn-sm btn-success" title="Cobrar no WhatsApp" target="_blank" rel="noreferrer"
                                                   href={linkWhatsApp(p.Emprestimo?.Empresa?.telefone, mensagemCobranca(p))}>
                                                    <i className="bi bi-whatsapp"></i> <span className="so-mobile-inline">Cobrar no WhatsApp</span>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </div>
                    }
                </div>

                {/* Próximos vencimentos */}
                <div className="he-card sem-rolagem" style={{flex: "1 1 420px", minWidth: 0}}>
                    <h5 className="he-titulo he-dourado"><i className="bi bi-calendar-week"></i> Vencendo nos próximos 7 dias</h5>
                    {alertas.proximosVencimentos.length === 0 ?
                        <Vazio icone="bi bi-calendar-week" titulo="Semana tranquila"
                               texto="Nada vencendo nos próximos 7 dias."/>
                        :
                        <div className="lista-rolavel">
                        <table className="table table-hover tabela-responsiva tabela-mini">
                            <thead><tr><th>Empresa</th><th>Parcela</th><th>Vence</th><th>Valor</th></tr></thead>
                            <tbody>
                                {alertas.proximosVencimentos.map((p) => (
                                    <tr key={p.id}>
                                        <td className="principal ordem-primeiro" data-rotulo="Empresa">{p.Emprestimo?.Empresa?.nomeFantasia || p.Emprestimo?.Empresa?.razaoSocial}</td>
                                        <td data-rotulo="Parcela">{p.numero}</td>
                                        <td data-rotulo="Vence">{dataBR(p.dataVencimento)}</td>
                                        <td className="destaque" data-rotulo="Valor">{real(p.valor)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </div>
                    }
                </div>
            </div>

            <div style={{display: "flex", gap: "1em", flexWrap: "wrap", marginTop: "1em"}}>
                {/* Gráfico 7 dias */}
                <div className="he-card sem-rolagem" style={{flex: "1 1 420px", minWidth: 0}}>
                    <h5 className="he-titulo"><i className="bi bi-bar-chart-fill he-dourado"></i> Últimos 7 dias</h5>
                    {/* o gráfico rola dentro do próprio card — a página nunca desliza */}
                    <div className="grafico-fluido grafico-fluido-semana">
                        <div className="grafico-fluido-trilho" style={{"--trilho-min": "240px", height: 160}}>
                            {grafico7dias.map((g) => (
                                <div key={g.dia} className="grafico-fluido-coluna">
                                    <div className="grafico-fluido-par" style={{height: 120}}>
                                        <div className="grafico-fluido-barra" title={`Entradas: ${real(g.entradas)}`} style={{background: "#2ecc71", height: Math.max((g.entradas / maiorValorGrafico) * 120, 2)}}></div>
                                        <div className="grafico-fluido-barra" title={`Saídas: ${real(g.saidas)}`} style={{background: "#ff6b5b", height: Math.max((g.saidas / maiorValorGrafico) * 120, 2)}}></div>
                                    </div>
                                    <span className="grafico-fluido-dia">{dataBR(g.dia).slice(0, 5)}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="legenda-grafico">
                        <span><i className="legenda-ponto" style={{background: "#2ecc71"}}></i> Entradas</span>
                        <span><i className="legenda-ponto" style={{background: "#ff6b5b"}}></i> Saídas</span>
                    </div>
                </div>

                {/* Últimas movimentações */}
                <div className="he-card sem-rolagem" style={{flex: "1 1 420px", minWidth: 0}}>
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap"}}>
                        <h5 className="he-titulo" style={{margin: 0}}><i className="bi bi-clock-history he-dourado"></i> Últimas movimentações</h5>
                        <Link to="/caixa" className="btn btn-sm btn-outline-he">Ver caixa</Link>
                    </div>
                    {ultimasMovimentacoes.length === 0 &&
                        <Vazio icone="bi bi-clock-history" titulo="Nenhuma movimentação ainda"
                               texto="Assim que entrar ou sair dinheiro, aparece aqui."/>
                    }
                    {ultimasMovimentacoes.length > 0 &&
                    <div className="lista-rolavel" style={{marginTop: "0.8em"}}>
                    <table className="table tabela-responsiva tabela-mini">
                        <tbody>
                            {ultimasMovimentacoes.map((m) => (
                                <tr key={m.id}>
                                    <td className="esconder-mobile" style={{width: 30}}><i className={m.tipo === "entrada" ? "bi bi-arrow-down-circle-fill" : "bi bi-arrow-up-circle-fill"} style={{color: m.tipo === "entrada" ? "#2ecc71" : "#ff6b5b"}}></i></td>
                                    <td className="principal ordem-primeiro" data-rotulo="Movimentação">{m.descricao || m.categoria}</td>
                                    <td data-rotulo="Data">{dataBR(m.data)}</td>
                                    <td className="destaque valor-dinheiro" data-rotulo="Valor" style={{color: m.tipo === "entrada" ? "#2ecc71" : "#ff6b5b"}}>{m.tipo === "entrada" ? "+" : "-"}{real(m.valor)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </div>
                    }
                </div>
            </div>
        </div>
    )
}
